import React from 'react';
import { motion } from 'framer-motion';

const workplaceData = [
    {
        id: 1,
        title: "AI-powered ERP Lite",
        description: "Flexible, lightweight, and easy to use, built to feel natural, smooth, and effortless in everyday use."
    },
    {
        id: 2,
        title: "Custom-built workflows",
        description: "That easily adapts to your business as it grows and changes."
    },
    {
        id: 3,
        title: "Automation-first design ",
        description: "To make everyday work easier by cutting out repetitive tasks."
    },
    {
        id: 4,
        title: "Affordable & Scalable ",
        description: "A great fit for SMBs and growing businesses, Glokode helps you go beyond daily operations and truly focus on unlocking steady, meaningful growth."
    }
];

const WhyGlodesk = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    return (
        <section className="w-full pb-[40px] md:pb-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeUpVariant}
                    className="mb-[32px] md:mb-[60px]"
                >
                    <h2 className="text-[20px] lg:text-[30px] text-center font-sora font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[16px]">
                        Why Glokode?
                    </h2>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    className="grid grid-cols-1 md:grid-cols-2 gap-[16px] md:gap-[24px]"
                >
                    {workplaceData.map((card) => (
                        <motion.div
                            key={card.id}
                            variants={fadeUpVariant}
                            className={`group relative flex flex-col bg-white border border-[#01386A45] p-[16px] sm:p-[20px] md:p-[30px] h-full min-h-[220px] sm:min-h-[280px] md:min-h-[320px] transition-all duration-300 overflow-hidden cursor-default md:hover:-translate-y-1 ${card.id === 3 ? 'sm:col-span-2 md:col-span-1' : ''
                                }`}
                        >
                            <h3 className="text-[16px] font-sora md:text-[20px] font-[600] text-[#01386A] mb-[16px] sm:mb-[30px] relative z-10 transition-colors duration-300 group-hover:text-white">
                                {card.title}
                            </h3>

                            {/* Description (Added group-hover text color change) */}
                            <p className="text-[#49577A] text-[14px]  md:text-[16px] font-graphik font-[500] leading-[1.6] mt-auto relative z-10 transition-colors duration-300 group-hover:text-white/90">
                                {card.description}
                            </p>

                            {/* Bottom to Top Background Fill Layer */}
                            <div className="absolute bottom-0 left-0 w-full h-0 bg-[#01386A] transition-all duration-500 ease-in-out group-hover:h-full z-0" />
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default WhyGlodesk;